var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 30,
    rx: 9,
    transform: "matrix(1 0 0 -1 0 30)",
    fill: "#4CB3D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9995 22.8C16.2995 22.8 15.5995 22.53 15.0695 22L8.54953 15.48C8.25953 15.19 8.25953 14.71 8.54953 14.42C8.83953 14.13 9.31953 14.13 9.60953 14.42L16.1295 20.94C16.6095 21.42 17.3895 21.42 17.8695 20.94L24.3895 14.42C24.6795 14.13 25.1595 14.13 25.4495 14.42C25.7395 14.71 25.7395 15.19 25.4495 15.48L18.9295 22C18.3995 22.53 17.6995 22.8 16.9995 22.8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9995 16.8C16.2995 16.8 15.5995 16.53 15.0695 16L8.54953 9.48001C8.25953 9.19001 8.25953 8.71001 8.54953 8.42001C8.83953 8.13001 9.31953 8.13001 9.60953 8.42001L16.1295 14.94C16.6095 15.42 17.3895 15.42 17.8695 14.94L24.3895 8.42001C24.6795 8.13001 25.1595 8.13001 25.4495 8.42001C25.7395 8.71001 25.7395 9.19001 25.4495 9.48001L18.9295 16C18.3995 16.53 17.6995 16.8 16.9995 16.8Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.be53af68.svg";
export { ForwardRef as ReactComponent };